  <div class="dashboard-wrapper d-flex">
    <main class="flex-grow-1 px-3">

      <!-- Header -->
      <header class="mb-4">
        <p class="fw-bold fst-italic fs-3 m-0 p-0">Welcome back, {{entity_name}}</p>
        <p class="text-dark text-xs mb-0">
          Track your profile, distributions, and building documents.
        </p>

        <!-- Alert -->
        <div class="alert alert-warning border-0 d-flex justify-content-between align-items-center mt-3 shadow-sm">
          <div class="d-flex align-items-center gap-3">
            <i class="fas fa-exclamation-triangle fs-4 text-warning"></i>
            <div>
              <strong class="d-block text-xs">Complete Your Profile</strong>
              <span class="text-xs">
                Your profile is 72% complete. Please upload required documents to receive distributions.
              </span>
            </div>
          </div>
          <button class="btn-close"></button>
        </div>
      </header>

      <!-- Stats -->
      <div class="row g-3 mb-4">
        <div class="col-md-3">
          <div class="glassy-table border rounded-lg p-3 shadow-sm h-100">
            <div class="mb-3 bg-danger-subtle text-danger rounded-3 d-inline-flex p-2">
              <i class="fas fa-user fs-4"></i>
            </div>
            <h4 class="fw-bold mb-1">72%</h4>
            <p class="text-dark text-xs mb-0">Profile Status</p>
            <small class="text-dark text-xxs">Complete to verify</small>
          </div>
        </div>

        <div class="col-md-3">
          <div class="glassy-table border rounded-lg p-3 shadow-sm h-100">
            <div class="mb-3 bg-warning-subtle text-warning rounded-3 d-inline-flex p-2">
              <i class="fas fa-shield-alt fs-4"></i>
            </div>
            <h4 class="fw-bold mb-1">Pending</h4>
            <p class="text-dark text-xs mb-0">KYC Status</p>
            <small class="text-dark text-xxs">2 documents required</small>
          </div>
        </div>

        <div class="col-md-3">
          <div class="glassy-table border rounded-lg p-3 shadow-sm h-100">
            <div class="mb-3 bg-success-subtle text-success rounded-3 d-inline-flex p-2">
              <i class="fas fa-wallet fs-4"></i>
            </div>
            <h4 class="fw-bold mb-1">R45,320</h4>
            <p class="text-dark text-xs mb-0">Distributions Received</p>
            <small class="text-dark text-xxs">Lifetime total</small>
          </div>
        </div>

        <div class="col-md-3">
          <div class="glassy-table border rounded-lg p-3 shadow-sm h-100">
            <div class="mb-3 bg-primary-subtle text-primary rounded-3 d-inline-flex p-2">
              <i class="fas fa-calendar fs-4"></i>
            </div>
            <h4 class="fw-bold mb-1">15 Mar</h4>
            <p class="text-dark text-xs mb-0">Next Distribution</p>
            <small class="text-dark text-xxs">Estimated R16,000</small>
          </div>
        </div>
      </div>

      <!-- Main Grid -->
      <div class="row g-4">

        <!-- Profile Completion -->
        <div class="col-lg-8">
          <div class="glassy-table border rounded-lg p-4 shadow-sm h-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h6 class="fw-bold mb-1">Profile Completion</h6>
                <small class="text-dark">3 of 6 steps complete</small>
              </div>
              <span class="fw-bold fs-5">72%</span>
            </div>

            <div class="progress mb-4" style="height:6px;">
              <div class="progress-bar bg-success" style="width:72%"></div>
            </div>

            <ul class="list-group list-group-flush mb-4 gap-3">
              <li class="list-group-item px-3 p-2">✓ Personal Information</li>
              <li class="list-group-item px-3 p-2">✓ Contact Details</li>
              <li class="list-group-item px-3 p-2">✓ Upload ID Document</li>
              <li class="list-group-item px-3 p-2 text-muted">4. Proof of Address</li>
              <li class="list-group-item px-3 p-2 text-muted">5. Banking Details</li>
              <li class="list-group-item px-3 text-muted">6. Tax Information</li>
            </ul>

            <button class="btn btn-primary-blue w-100 rounded text-xs">
              Complete Profile
            </button>
          </div>
        </div>

        <!-- Distribution -->
        <div class="col-lg-4">
          <div class="glassy-table border rounded-lg p-4 shadow-sm h-100">
            <h6 class="fw-bold mb-3">Distributions</h6>

            <div class="bg-light rounded-3 p-3 mb-3">
              <small class="text-muted d-block">Total Distributed (YTD)</small>
              <h5 class="fw-bold mb-1">R 45 320</h5>
              <small class="text-success">
                <i class="fas fa-arrow-trend-up"></i> +12.5% from last year
              </small>
            </div>

            <div class="border border-success rounded-3 p-3">
              <small class="text-success fw-bold d-block">Next Distribution</small>
              <h6 class="fw-bold mb-1">R 16 000</h6>
              <small class="text-muted">Expected on 15 Mar 2025</small>
            </div>
          </div>
        </div>

        <!-- Recent Documents -->
        <div class="col-lg-8">
          <div class="glassy-table border rounded-lg p-4 shadow-sm h-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="fw-bold m-0">Recent Documents</h6>
              <a href="#" class="text-primary-blue small fw-bold text-decoration-none">
                View All
              </a>
            </div>

            <div class="list-group list-group-flush">
              <div class="list-group-item d-flex justify-content-between align-items-center px-3 p-2">
                <div>
                  <p class="fw-bold small mb-1">Trust Deed - Amended 2024</p>
                  <small class="text-muted">Legal • 15 Jan 2024</small>
                </div>
                <button class="btn btn-link p-0 text-muted border-0">
                  <i class="far fa-eye"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Meetings -->
        <div class="col-lg-4">
          <div class="glassy-table border rounded-lg p-4 shadow-sm h-100 d-flex flex-column">
            <h6 class="fw-bold mb-3">Upcoming Meetings</h6>

            <div class="mb-3">
              <span class="badge bg-success text-white small mb-1">Trustee Meeting</span>
              <p class="fw-bold small mb-1">Q1 Trustee Review Meeting</p>
              <small class="text-muted">
                28 Jan 2025 • 10:00 AM
              </small>
            </div>

            <button class="btn btn-primary-dark text-xs mt-auto w-100">
              View Calendar
            </button>
          </div>
        </div>

      </div>
    </main>
  </div>